import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, method: { type: String, default: "POST" } }

  async fire(event) {
    event.preventDefault()

    const button = event.currentTarget
    button.disabled = true
    const originalHTML = button.innerHTML
    button.innerHTML = `<svg class="animate-spin h-3 w-3 mr-1 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg> Scanning…`

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.urlValue, {
        method: this.methodValue,
        headers: {
          "X-CSRF-Token": token,
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        this.showToast("Scanning for Roam links in the background. Transcripts will appear as comments shortly.", "success")
      } else {
        this.showToast("Something went wrong. Please try again.", "error")
      }
    } catch {
      this.showToast("Something went wrong. Please try again.", "error")
    } finally {
      button.disabled = false
      button.innerHTML = originalHTML
    }
  }

  showToast(message, type) {
    const colors = type === "success"
      ? "bg-green-50 text-green-800 border-green-200"
      : "bg-red-50 text-red-800 border-red-200"

    const toast = document.createElement("div")
    toast.className = `fixed bottom-6 right-6 z-50 max-w-sm px-4 py-3 rounded-lg border shadow-lg transition-all duration-300 opacity-0 translate-y-2 ${colors}`
    toast.innerHTML = `<div class="flex items-start gap-2">
      <p class="text-sm font-medium">${message}</p>
      <button onclick="this.closest('div.fixed').remove()" class="ml-2 flex-shrink-0 text-current opacity-50 hover:opacity-100">&times;</button>
    </div>`

    document.body.appendChild(toast)
    requestAnimationFrame(() => {
      toast.classList.remove("opacity-0", "translate-y-2")
    })

    setTimeout(() => {
      toast.classList.add("opacity-0", "translate-y-2")
      setTimeout(() => toast.remove(), 300)
    }, 6000)
  }
}
